<template>
  <div>
    <el-card class="box-card" v-loading="loading">
      <div slot="header" class="box-header">
        <span class="box-header__title">Список анкет</span>
        <el-button
          class="box-header__button"
          size="mini"
          @click="addQuestionnaire"
          type="primary"
          name="add"
        >Добавить
        </el-button>
      </div>

      <template>
        <el-table :data="tableData" class="edit-table">
          <el-table-column prop="id" label="id"></el-table-column>
          <el-table-column prop="title" label="Название">
            <template slot-scope="scope">
              <el-link type="primary" @click="handleEdit(scope.row.id)">
                {{
                  scope.row.title
                }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="Описание">
            <template slot-scope="scope">{{ scope.row.description | longText }}</template>
          </el-table-column>
          <el-table-column prop="questions.length" label="Вопросов"></el-table-column>
          <el-table-column fixed="right" align="center" width="140" label="Действия">
            <template slot-scope="scope">
              <el-tooltip content="Редактировать" placement="top">
                <el-button
                  class="table__btn"
                  size="mini"
                  type="primary"
                  icon="el-icon-edit"
                  circle
                  name="edit"
                  @click="handleEdit(scope.row.id, scope.row)"
                />
              </el-tooltip>
              <el-tooltip content="Удалить" placement="top">
<!--                <el-popconfirm-->
<!--                  class="confirmBtn"-->
<!--                  @onConfirm="deleteQuestionnaire(scope.row.id, scope.$index)"-->
<!--                  title="Вы уверены?"-->
<!--                  confirmButtonText="Да"-->
<!--                  confirmButtonType="danger"-->
<!--                  cancelButtonType="default"-->
<!--                  cancelButtonText="Нет"-->
<!--                slot="reference"-->
<!--                >-->
                  <el-button
                    @click="open(scope.row.id, scope.$index)"
                    size="mini"
                    icon="el-icon-delete"
                    circle
                    class="table__btn"
                    type="danger"
                    name="delete"
                  />
<!--                </el-popconfirm>-->
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <div class="error-load" v-if="errorLoadCard">
        <p>Ошибка загрузки</p>
        <el-button type="danger" @click="loadLogic">Загрузить еще раз</el-button>
      </div>
    </el-card>

    <questionnaire-add
      :visible="visibleQuestionnaireAddModal"
      @close="visibleQuestionnaireAddModal = false"
    />

  </div>
</template>

<script>
import QuestionnaireAdd from '@/components/dialog/questionnaire/Add.vue'

export default {
  name: 'Questionnaire',
  data () {
    return {
      tableData: null,
      loading: false,
      errorLoadCard: false,
      questionnaire: {
        title: null,
        description: null
      },
      error: null,
      cardId: null,
      visibleQuestionnaireAddModal: false
    }
  },
  created () {
    this.loading = !!1
    this.loadLogic()
  },
  filters: {
    longText (t) {
      return t.length <= 150 ? t : t.substr(0, 150) + '...'
    }
  },
  components: { QuestionnaireAdd },
  methods: {
    loadLogic () {
      this.$api.questionnaire
        .getList()
        .then((response) => {
          this.tableData = response.data
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка загрузки списка',
            message: response.response.data.message
          })
        })
        .finally(() => {
          this.loading = !!0
        })
    },
    open (id, idIndex) {
      const h = this.$createElement
      this.$msgbox({
        title: 'Удалить анкету',
        message: h('p', null, [
          h('span', null, 'Вы уверены, что хотите удалить анкету “Периферическая сосудистая система”?')
        ]),
        customClass: 'my-delete',
        showCancelButton: true,
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Отменить',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = 'Загрузка...'

            this.deleteQuestionnaire(id, idIndex, instance).then(() => {
              instance.confirmButtonLoading = false
              done()
            })
            // done()
          } else {
            done()
          }
        }
      }).then((action, instance) => {

      })
    },
    handleEdit (id) {
      this.$router.push({
        name: 'cpanel.questionnaire.item',
        params: {
          id
        }
      })
    },
    addQuestionnaire () {
      this.visibleQuestionnaireAddModal = !!1
    },
    deleteQuestionnaire (id, idIndex, done) {
      return new Promise((resolve, reject) => {
        this.$api.questionnaire
          .delete(id)
          .then((response) => {
            this.loadData = response.data
            this.$notify.success({
              title: 'Успешно',
              message: 'Анкета удалена'
            })
            this.tableData.splice(idIndex, 1)
            resolve()
          })
          .catch((response) => {
            this.$notify.error({
              title: 'Ошибка удаления',
              message: response.response.data.message
            })
          })
          .finally(() => {
          })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.box-card {
  max-width: 1960px;
  margin: 0 auto;

  &__title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 18px;
    color: #303133;

    display: flex;
    align-items: flex-end;
  }

  &__btns {
    text-align: center;
    margin: 50px 0 0 0;
  }
}

.table {
  width: 100%;

  &__btn {
    margin: 5px;
  }
}

.box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__title {
    font-weight: bold;
    font-size: 16px;
    line-height: 18px;

    color: #303133;
  }
}
</style>
